import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import Component, { type ContentContainerProps } from "./component";
import { classNameSelector } from "./selectors";

const STYLE: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  position: "relative",
  height: "100%",
  width: "100%",
  minWidth: 0
};
const mapStateToProps = (state: AppState, props: WithChildren): ContentContainerProps => ({
  children: props.children,
  className: classNameSelector(state),
  style: STYLE
});

export default connectCustom(mapStateToProps)(Component);
